import $ from "jquery";

$(function() {
  $('#medical_status_body_condition_id').on('change', function() {
    const bodyCondition = $('#medical_status_body_condition_id option:selected').text();
    if(bodyCondition === "中等症" || bodyCondition === "重症") {
      $('#medical_status_under_oxygen_inhalation').prop("checked", true)
    }
  });
});